// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__5vVaw","modal":"Modal_modal__1b1-a","slide-down":"Modal_slide-down__2r_ry"};